import { Button, message, Tooltip } from 'antd';
import { FileExcelFilled } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
  PresentmentDashboard,
  // presentmentDashboardAutopayFalseFilter,
  presentmentDashboardAutopayFalseFilterBulkUpload,
  PresentmentFilterPaylaod,
  uploadPresentmentUrl,
} from 'api/nach';
import { useAutoPayFalseTabsContext } from '..';
import { usePresentmentFilterContext } from 'features/nach/presentment/context/PresenmentFilterProvider';
import moment from 'moment';
import Loading from 'features/nach/components/Loading';

type Props = {
  // filter: FilterPayload;
  // reload: boolean;
  // data: PresentmentDashboard[];
};
function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss');
    return dateMoment;
  }
}

const headers = [
  { label: 'Presentment ID', key: 'presentmentId' },
  { label: 'UMRN NO', key: 'umrnNO' },
  { label: 'Transaction ID REF', key: 'transactionIDREF' },
  { label: 'Date Of Txn', key: 'dateOfTxn' },
  { label: 'Action(HOLD or Process)', key: '' },
  { label: 'Reason', key: '' },
];

export const BulkUploadFile = ({ }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { filter } = usePresentmentFilterContext();
  const [selectedFile, setSelectedFile] = useState();
  const { setReload } = useAutoPayFalseTabsContext();
  const [downLoadList, setDownLoadList] = useState<PresentmentDashboard[]>([]);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const onFileChange = (event: any) => {
    console.log(event.target);
    const file = event.target.files[0];
    if (
      file &&
      file.type == 'text/csv'
      // ||file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setSelectedFile(file);
    } else {
      message.error('Please select valid file.');
    }
  };

  const handleUpload = useCallback(async () => {
    if (!selectedFile) {
      message.error('Please select file.');
      return;
    }
    setIsLoading(true);
    console.log(selectedFile);
    const formdata = new FormData();

    formdata.append('reuploadId', '2');
    formdata.append('presentmentFile', selectedFile);
    try {
      const response = axios.post(uploadPresentmentUrl, formdata);
      const res = await response;
      console.log('presentment uploaded response', res);
      if (res.status == 200) {
        message.success('Success');
        setReload((prev: boolean) => !prev);
        setSelectedFile(undefined);
      }
    } catch (error) {
      message.error('Failed to upload data!!.');
    } finally {
      setIsLoading(false);
    }
  }, [selectedFile]);

  const handleDownload = useCallback(async () => {
    if (!filter || !filter.startDate || !filter.endDate) {
      message.warn('Please txn select date.');
      return;
    }
    setIsLoading(true);
    console.log('presentment filter data download', filter);
    const newFilter1: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 3,
      autopayFlaseFilterMsg: 'NOTIFIED',
    };
    presentmentDashboardAutopayFalseFilterBulkUpload(newFilter1)
      .then((res) => {
        console.log('presentment response data download', res);
        if (res.data) {
          console.log('presentment response data download', res.data);
          const newData = res.data.data.map((item: any) => ({
            ...item,
            dateOfTxn: getFullDate(item.dateOfTxn),
          }));
          console.log('presentment response data download----', res.data);
          if (newData.length == 0) {
            buttonRef.current?.click();
          }
          console.log('presentment response data download-22---', res.data);
          setDownLoadList(newData);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);

  useEffect(() => {
    if (downLoadList.length > 0 && buttonRef && buttonRef.current) {
      buttonRef.current.click();
    }
  }, [downLoadList]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '40px' }}>
        <Loading isLoading={isLoading} />
        <input type="file" onChange={onFileChange} />
        <Button type="primary" style={{ float: 'right', marginTop: '-3px' }} onClick={handleUpload}>
          Upload file
        </Button>
        <Tooltip title="Download">
          <Button
            onClick={handleDownload}
            type="link"
            icon={<FileExcelFilled />}
            style={{ float: 'right', fontSize: '30px', color: 'green', marginTop: '-3px' }}
          />
          <CSVLink
            data={downLoadList}
            headers={headers}
            style={{ display: 'none' }}
            separator=","
            filename="PresentmentPeingingData.csv"
          >
            <Button ref={buttonRef}>Download</Button>
          </CSVLink>
        </Tooltip>
      </div>
    </>
  );
};
